<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <a-card :bordered="false">
      <!-- <j-dict-select-tag
        :defaultShowAll="true"
        type="radioButton"
        v-model="queryParam.type"
        :trigger-change="true"
        placeholder="请选择分类"
        :defaultDictOptions="[{title: '全部', text: '全部', description:'', value: ''},
                  {title: '科普名家', text: '科普名家', description:'', value: '1'},
                  {title: '科普达人', text: '科普达人', description:'', value: '2'}]"
      /> -->
      <a-form-item label="分类" :labelCol="{xs: { span: 8 },sm: { span: 2 }}" :wrapperCol="{xs: { span: 16 },sm: { span: 22 }}">
          <a-radio-group button-style="solid" v-model="queryParam.orderBy" @change="getList">
            <a-radio-button value="time">
              科普名家
            </a-radio-button>
            <a-radio-button value="view">
              科普达人
            </a-radio-button>
          </a-radio-group>
        </a-form-item>
      <a-divider />
      <a-skeleton v-if="loading" />
      <a-list :dataSource="dataSource" :pagination="pagination">
        <a-list-item slot="renderItem" slot-scope="item, index">
          <a-card :bordered="false" @click="toDetail(item)">
            <a-row type="flex" :gutter="24">
              <a-col :span="8" class="animate__animated animate__fadeIn">
                <PhotoCard :img="item.cmsCover_url">
                  <div slot="content">
                    {{ item.cmsTitile }}
                  </div>
                </PhotoCard>
              </a-col>
              <a-col :span="16" class="animate__animated animate__slideInRight ">
                <div class="people">
                  <a>
                    <h3 class="name">{{ item.cmsTitile }}</h3>
                    <a-tag class="title" color="blue">院士</a-tag>
                  </a>
                  <p class="people-desc">
                    {{ item.cmsDesc }}
                  </p>
                </div>
              </a-col>
            </a-row>
            <!-- <a-row type="flex" :gutter="24" v-if="index % 2 == 1">
              <a-col :span="16" class="animate__animated animate__slideInLeft">
                <div class="people-desc">
                  <h3 class="title">{{ item.cmsTitile }}</h3>
                  <p>
                    {{ item.cmsDesc }}
                  </p>
                </div>
              </a-col>
              <a-col :span="8" class="animate__animated animate__fadeIn">
                <PhotoCard :img="item.cmsCover_url">
                  <div slot="content">
                    {{ item.cmsTitile }}
                  </div>
                </PhotoCard>
              </a-col>
            </a-row> -->
          </a-card>
        </a-list-item>
      </a-list>
    </a-card>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction } from "@/api/manage";
import JDictSelectTag from "@/components/jeecg/JDictSelectTag";
import { mixinDevice } from "@/utils/mixin.js";
import "@/assets/less/animation.css";
import PhotoCard from "@/components/common/PhotoCard"

export default {
  mixins: [mixinDevice],
  components: {
    JDictSelectTag,
    PhotoCard
  },
  data() {
    return {
      dataSource: [],
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: this._isMobile() ? 8 : 12,
      },
      loading: true,
      productType: "",
      tenantConfig: {},
      videoVisible: false,
      currentItem: {},
      queryParam:{}
    };
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.getList();
  },
  mounted() {},
  methods: {
    getList() {
      this.loading = true;
      this.dataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsType: 7,
        pageSize: 999,
        cmsStatus: 1,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.dataSource = res.result.records;
        }
        this.loading = false;
      });
    },
    toDetail(item) {
      let route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.people {
  padding: 20px 10px;
  .name {
    display: inline-block;
    margin-top: 5px;
    font-size: 20px;
    font-weight: 600;
  }
  .name:hover {
    color: #1890ff;
  }
  .title{
    margin-left: 20px;
    display: inline-block;
  }
  .desc{
    display: block;
  }
}
.img-zoom {
  width: 100%;
  height: auto;
  max-height: 380px;
  border-radius: 4px;
  box-shadow: rgb(179, 179, 179) 0px 0px 5px;
  img {
    width: 100%;
    height: 100%;
  }
}

.search-card {
  /deep/.ant-card-body {
    padding: 20px;
  }
}
/deep/.ant-list-item {
  // cursor: pointer;
  .ant-card-body {
    padding: 0;
  }
}
.mobile {
  .cover {
    height: 100px !important;
  }
}
</style>